import { BaseComponent } from 'components/BaseComponent';
import styled from 'styled-components';
import PropTypes from 'prop-types';
import { createStructuredSelector } from 'reselect';
import { connect } from 'react-redux';
import { compose } from 'redux';
import { withRouter } from 'react-router-dom';
import React from 'react';
import { Button } from '../../../components/Buttons';
import styles from './VehicleGetProductInvoices.module.css';

const Container = styled.div`
  font-size: 14px;

  .cell:first-child {
    text-transform: capitalize;
  }
`;

/* eslint-disable react/prefer-stateless-function */
class VehicleGetProductInvoiceCardComp extends BaseComponent {
  constructor(props) {
    super(props);
  }

  onReset() {
    this.setState({ ...STATE });
  }

  render() {
    return (
      <div className={styles.containerButton}>
        <Button
          className={styles.buttonOpenModal}
          onClick={() => this.to(`/invoices/product-invoices/vehicle/${this.props.vehicle?.id}`)}
        >
          {this.lbl('vehicle.details.productInvoicesBtn')}
        </Button>
      </div>
    );
  }
}

VehicleGetProductInvoiceCardComp.propTypes = {
  dispatch: PropTypes.func.isRequired,
};

const mapStateToProps = (state, ownProps) => createStructuredSelector({});

function mapDispatchToProps(dispatch, ownProps) {
  return {
    dispatch,
  };
}

const withConnect = connect(mapStateToProps, mapDispatchToProps);

export const VehicleGetProductInvoicesCard = compose(withConnect, withRouter)(VehicleGetProductInvoiceCardComp);
